<template>
  <el-image
    class="info-table-image"
    :preview-src-list="srcList"
    :src="getSrc(urlFile, diskName)"
    @click="zoom(getSrc(urlFile, diskName))"
    alt="Sin Imagen"
  >
    <div slot="error" class="image-slot"></div>
  </el-image>
</template>
<script>
import { getSrcFromImage } from 'src/util/Util.js';

export default {
  name: 'image-with-zoom',
  props: {
    urlFile: {
      type: String,
    },
    diskName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      srcList: [],
    };
  },
  methods: {
    getSrc(url, disk = '') {
      return getSrcFromImage(url, disk);
    },
    zoom(url) {
      this.srcList = [];
      this.srcList.push(url);
    },
  },
};
</script>
<style>
.info-table-image {
  width: 150px !important;
}
</style>
